<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
// import { defineProps } from "vue";
import Box from "./Box.vue";
import designImage from "../../assets/images/undraw_complete_design_re_h75h.svg";
import photographyImage from "../../assets/images/undraw_landscape_photographer_ivc6.svg";
import videographyImage from "../../assets/images/undraw_videographer_d5rn.svg";
import photoEditImage from "../../assets/images/undraw_optimize_image_re_3tb1.svg";
import videoEditImage from "../../assets/images/undraw_video_upload_3d4u.svg";
import stockPhotoImage from "../../assets/images/undraw_mobile_photos_psm5.svg";

const designText = "Freezing moments in time, revealing beauty in every frame.";
const photoText =
  "Transforming ideas into stunning visuals that captivate and inspire.";
const videographyText =
  "Bringing stories to life through dynamic visuals and seamless motion.";
const photoEditText =
  "Enhancing images with precision and creativity, turning ordinary into extraordinary.";
const videoEditText =
  "Crafting cinematic narratives, shaping raw footage into compelling stories.";
const stockPhotoText =
  "Access a vast collection of high-quality visuals for your creative projects.";
const photoHead = "Photography";
const designHead = "Design";
const videographyHead = "Videography";
const photoEditHead = "Photo Editing";
const videoEditHead = "Video Editing";
const stockPhotoHead = "Stock Photography";
</script>

<template>
  <section class="flex justify-center items-center">
    <div class="my-36 flex-col justify-center items-center w-[90%]">
      <div class="flex justify-center items-center my-20">
        <h1 class="text-2xl font-bold text-white nav-links">
          My <span class="text-yellow-800">Services</span>
        </h1>
      </div>

      <!-- services container -->
      <div
        class="flex flex-wrap justify-around items-center w-[85%]"
        :style="{ margin: '0 auto' }"
      >
        <Box :head="photoHead" :text="photoText" :image="photographyImage" />
        <Box :head="designHead" :text="designText" :image="designImage" />
        <Box :head="videographyHead" :text="videographyText" :image="videographyImage" />
        <Box :head="photoEditHead" :text="photoEditText" :image="photoEditImage" />
        <Box :head="videoEditHead" :text="videoEditText" :image="videoEditImage" />
        <Box :head="stockPhotoHead" :text="stockPhotoText" :image="stockPhotoImage" />
      </div>
    </div>
  </section>
</template>
